module.exports = __webpack_public_path__ + "img/classic.d4d4915.jpg";